import { useSearchParams } from 'react-router-dom';
import { BuddySprite } from '../components/BuddySprite.tsx';
// Deep import, not the barrel: this route is in the main entry chunk (see BuddySprite.tsx).
import { MASCOT_IDS, type MascotId } from '@jubuddy/buddy-core/types/ids.ts';

/**
 * Embed route — renders a single companion buddy for iframe hosts.
 * Phase 4+ wires postMessage bridge (jubuddy:ready, jubuddy:buddy-nudge, etc).
 */
export function EmbedCompanionPage() {
  const [params] = useSearchParams();
  const requested = params.get('mascot') ?? 'jubit';
  const mascot = (MASCOT_IDS.includes(requested as MascotId) ? requested : 'jubit') as MascotId;

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-transparent">
      <BuddySprite buddyId={mascot} />
    </div>
  );
}
